import type * as ents from '@attain-apps/entities'
import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as dms from '../../../dms'
import type * as me from '../../../me'
import type * as models from '../../models'

import type { ActionHandlers } from './action-handlers'
import { Api } from './api'
import type { Context, TypeParams } from './type-params'

export interface Config {
  // TODO: update documentation
  ref: models.widget.Ref
  /** @see {@link ents.core.mosaic.Widget.Rendering} */
  rendering: ents.core.mosaic.Widget.Rendering<ents.core.mosaic.Widget.Type.Table>
  /** @see {@link dms.schema.Feature} */
  schemaFeature: dms.schema.Feature
  /** @see {@link me.Feature} */
  meFeature: me.Feature
  /** @see {@link ActionHandlers} */
  actionHandlers?: Partial<ActionHandlers>
}
export namespace Config {
  export function getApi({
    schemaFeature,
    rendering,
  }: Config): ec.models.Api<TypeParams> {
    return TypeChecker.isNotNullish(rendering.content?.count)
      ? new Api.WithCount(schemaFeature.selectors.schema.asObservable)
      : new Api(schemaFeature.selectors.schema.asObservable)
  }

  export function getContext$({
    meFeature,
    rendering: { content },
  }: Config): rxjs.Observable<Context> {
    return meFeature.contexts.selectors.zoneContext.asObservable.pipe(
      rxjs.map(context => {
        if (!context) {
          return undefined
        }

        if (!content) {
          return undefined
        }

        return {
          ...context,
          content,
        }
      }),
    )
  }
}
